import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { logoutFromHelper } from "api/Helper.js";
import { pathGenerators } from "utils/routes";
import { getServerErrorMessage } from "utils/showMutationError";

import { logout } from "../redux/auth/AuthSlice.js";
import { removeuser } from "../redux/user/userSlice.js";

export const useHandleNetworkError = (genericMessage) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (error) => {
    console.error(error);

    if (error?.response?.status === 403) {
      logoutFromHelper();
      dispatch(logout());
      dispatch(removeuser());
      navigate(pathGenerators.auth.logout());
      return;
    }

    // The backend's reason if it sent one, the caller's line otherwise. This used to
    // show the caller's line unconditionally, so a validation failure explained by the
    // server arrived as "Something went wrong" — across 74 call sites (KIN-1725).
    toast.error(
      getServerErrorMessage(
        error,
        genericMessage || "Something went wrong. Please try again."
      )
    );
  };
};
